import * as React from 'react';
import { Redirect } from 'react-router-dom';
import DocumentPage from '../document/DocumentPage';

function AdminDocumentsList() {
    const [goToDocumentView, setGoToDocumentView] = React.useState(false);
    const [documentId, setDocumentId] = React.useState(0);

    function goToDoc(docId?: number) {
        setDocumentId(docId ?? 0);
        setGoToDocumentView(true);
    }

    if (goToDocumentView) {
        return <Redirect to={'/administrationdocument/' + documentId} />;
    }

    return <div>
        <DocumentPage isAdminPage={true} goToDocumentView={goToDoc} />
    </div>;
}

export default AdminDocumentsList;
